module.exports = __webpack_public_path__ + "img/testimony.28949b3b.jpg";